import { render } from "./StakeBalance.vue?vue&type=template&id=09e4780c"
import script from "./StakeBalance.vue?vue&type=script&setup=true&lang=js"
export * from "./StakeBalance.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"scripts/stake/StakeBalance.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "09e4780c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('09e4780c', __exports__)) {
    api.reload('09e4780c', __exports__)
  }
  
  module.hot.accept("./StakeBalance.vue?vue&type=template&id=09e4780c", () => {
    api.rerender('09e4780c', render)
  })

}


export default __exports__